import React, { useEffect, useState } from 'react';
import './About.css';
import backgroundImage from '../assets/ai-hero.png';

import { FaBrain, FaLock, FaRocket, FaHandshake, FaChartLine } from 'react-icons/fa';

const About = () => {
  const [counters, setCounters] = useState({
    years: 0,
    projects: 0,
    clients: 0,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setCounters((prev) => {
        const newCounters = {
          years: Math.min(prev.years + 1, 10),
          projects: Math.min(prev.projects + 10, 250),
          clients: Math.min(prev.clients + 1, 85),
        };
        return newCounters;
      });
    }, 50);

    return () => clearInterval(interval);
  }, []);

  const aboutList = [
    {
      icon: <FaBrain />,
      text: "Experts in AI, Web, Cloud & Mobile",
    },
    {
      icon: <FaLock />,
      text: "Focused on performance and security",
    },
    {
      icon: <FaRocket />,
      text: <strong>Scalable Cloud Architecture</strong>,
      subtext: " – AWS/Azure/GCP-optimized infrastructure with auto-scaling",
    },
    {
      icon: <FaHandshake />,
      text: <strong>Client-Centric Approach</strong>,
      subtext: " – Agile development with transparent communication",
    },
    {
      icon: <FaChartLine />,
      text: <strong>Results-Driven</strong>,
      subtext: " – Focused on measurable business outcomes and ROI",
    },
  ];

    const titleStyle = {
    fontSize: '2.5rem',
    fontWeight: '800',
    center: 'center',
    marginBottom: '20px',
    textShadow: '0 2px 10px rgba(0,0,0,0.6)',
      textAlign: 'center',
    color: '#8f69c8',
  };

  return (
    <section
      className="about-section dark-mode"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(15, 23, 42, 0.95), rgba(30, 41, 59, 0.95)), url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      <h2 style={titleStyle}>About Us</h2>
      <div className="about-content">
        <p className="about-intro">
          We engineer intelligent digital solutions that transform businesses through cutting-edge technology. As innovators at the intersection of AI, cloud computing, and enterprise software, we bridge vision with execution – delivering future-proof systems that drive measurable results.
        </p>

        <div className="about-counters">
          <div>
            <h3>{counters.years}+</h3>
            <p>Years Experience</p>
          </div>
          <div>
            <h3>{counters.projects}+</h3>
            <p>Projects Delivered</p>
          </div>
          <div>
            <h3>{counters.clients}+</h3>
            <p>Satisfied Clients</p>
          </div>
        </div>

        <ul className="about-list">
          {aboutList.map((item, index) => (
            <li key={index} className="about-list-item">
              <span className="about-icon">{item.icon}</span>
              <span>
                {item.text}
              
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default About;
